<script lang="ts">
    import type {ComponentStyle} from '../types';

    export let collapseTargetId: string;
    export let panelStyle: ComponentStyle = 'default';
</script>

<template>
    <div class="panel panel-{panelStyle}" on:mouseenter on:mouseleave>
        <div class="panel-heading" role="tab">
            <slot name="heading"></slot>
        </div>
        <div id="{collapseTargetId}" class="panel-collapse collapse">
            <div class="panel-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style lang="less">

</style>